// src/padplanner/EditorRoute.jsx
//
// The /padplanner/plans/$planId/edit route's component. It lives here, not
// in router.jsx, so router.jsx declares no new component (react-refresh/
// only-export-components). The param is read unscoped, as PlanPage reads
// ?tab=, so this file needs no import of the route object.
import { useParams } from "@tanstack/react-router";
import EditorPage from "./EditorPage";

export default function EditorRoute() {
  const { planId } = useParams({ strict: false });
  return <EditorPage planId={planId} />;
}
